/**
 * @flow
 * @relayHash 46fffee5ea0454a065ac19f533daf5da
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Main_viewer$ref = any;
export type ArticleStateType = "available" | "deleted" | "draft" | "%future added value";
export type Main_Refetch_QueryVariables = {|
  page: number,
  search?: ?string,
  states?: ?$ReadOnlyArray<?ArticleStateType>,
|};
export type Main_Refetch_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: Main_viewer$ref
  |}
|};
export type Main_Refetch_Query = {|
  variables: Main_Refetch_QueryVariables,
  response: Main_Refetch_QueryResponse,
|};
*/


/*
query Main_Refetch_Query(
  $page: Int!
  $search: String
  $states: [ArticleStateType]
) {
  viewer {
    ...Main_viewer_4vb9e5
    id
  }
}

fragment Main_viewer_4vb9e5 on Viewer {
  articles: articlesPaginate(pageSize: 12, page: $page, plainSearch: $search, states: $states) {
    totalCount
    articles {
      id
      title
      sectionName
      section
      availableAt
      state
      authorName
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "states",
    "type": "[ArticleStateType]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "Main_Refetch_Query",
  "id": null,
  "text": "query Main_Refetch_Query(\n  $page: Int!\n  $search: String\n  $states: [ArticleStateType]\n) {\n  viewer {\n    ...Main_viewer_4vb9e5\n    id\n  }\n}\n\nfragment Main_viewer_4vb9e5 on Viewer {\n  articles: articlesPaginate(pageSize: 12, page: $page, plainSearch: $search, states: $states) {\n    totalCount\n    articles {\n      id\n      title\n      sectionName\n      section\n      availableAt\n      state\n      authorName\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Main_Refetch_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Main_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search",
                "type": null
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Main_Refetch_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "articles",
            "name": "articlesPaginate",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "page",
                "variableName": "page",
                "type": "Int"
              },
              {
                "kind": "Literal",
                "name": "pageSize",
                "value": 12,
                "type": "Int"
              },
              {
                "kind": "Variable",
                "name": "plainSearch",
                "variableName": "search",
                "type": "String"
              },
              {
                "kind": "Variable",
                "name": "states",
                "variableName": "states",
                "type": "[ArticleStateType]"
              }
            ],
            "concreteType": "ArticlesPagination",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "articles",
                "storageKey": null,
                "args": null,
                "concreteType": "Article",
                "plural": true,
                "selections": [
                  v1,
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "title",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sectionName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "section",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "availableAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "state",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "authorName",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          v1
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c96492a0e12cf03f30875e0d84f9344f';
module.exports = node;



// WEBPACK FOOTER //
// src/components/main/__generated__/Main_Refetch_Query.graphql.js